import { adgColorsKeys, getColor } from './adg-colors';
type validAngles = '0' | '45' | '90' | '135' | '180' | '225' | '270' | '315';
export const getGradient = (
  angle: validAngles,
  color1: adgColorsKeys,
  color2: adgColorsKeys
): string => {
  return `linear-gradient(${angle}deg, ${getColor(color1)}, ${getColor(
    color2
  )})`;
};
